import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    forgotPasswordContainer: {
        alignItems: "center"
    },
    switchersContainer: {
        flexDirection: "row",
        position: "absolute"
    },
    guestButtonContainer: {
        alignItems: "center"
    },
    formContainer: {
        width: "100%",
        maxWidth: 400
    },
    logo: {
        height: 150,
        width: 150
    }
});

export default stylesheet;
